import base from '../config/base'

export const appName = '众英达赏聘网'

//搜索下拉类型
export enum SearchSelectTypes {
	HOME,
	JOB,
	CITY,
	COMPANY,
}

/**
 * 图表类型
 */
export enum PlotTypes {
	PIE,
	PIE_RING,
}

export enum PlotShape {
	CIRCLE,
	SQUARE,
}

export const SOURCE = 'source'
export const LOGIN_TOKEN = 'login/token'
export const LOGIN_SIGN = 'login/sign'
export const APPID = 'SDKAppID'
export const USER_CODE = 'userID'
export const USER_SIGN = 'userSig'
export const USER_DATA = 'userData'
export const LOGIN_DATA = 'loginData'
export const USERINFO = 'userInfo'
export const REGION_FENCE = 'regionFence'
export const SEARCH_HISTORY = 'searchHistory'
export const COMPANY_REGISTRY_TOKEN = 'companyRegistryToken'
export const ROLE_CLIENT = 'role_client'
export const ROLE_ENTERPRISE = 'role_enterprise'
//用户来源
export const SOURCE_CLIENT = 'source_client'
//企业来源
export const SOURCE_ENTERPRISE = 'source_enterprise'
export const SOURCE_CS = 'source_cs'
export const CHAT_TYPE = 'chatType'
export const WECHAT_CONFIG = 'wechat_config'
//联系人code
export const CONTACTS_CODE = 'contacts_code'
/**
 * 聊天类型
 */
export const chatTypes = {
	chatMessage: 'chatMessage',
	chatGroup: 'chatGroup',
	chatRoom: 'chatRoom',
	chatBoss: 'chatBoss',
	chatCustomer: 'chatCustomer',
}

export const CHAT_MSG_CUSTOM_TYPE = {
	SERVICE: 'consultion',
	EVALUATE: 'evaluation',
	LINK: 'text_link',
	CALL: 1,
	ORDER: 'order',
	JOB_RESUME: 'Job_Resume',
	INTERVIEW: 'interview',
}

export enum LayoutType {
	HORIZONTAL,
	VERTICAL,
}

export enum OperationType {
	ADD,
	EDIT,
	DELETE,
	OPEN_DIALOG,
}

export enum PlacementType {
	'top',
	'top-start',
	'top-end',
	'bottom',
	'bottom-start',
	'bottom-end',
	'left',
	'left-start',
	'left-end',
	'right',
	'right-start',
	'right-end',
}

export enum TroubleshootType {
	SELECT_SCENE,
}

export interface IPropType {
	[propName : string] : any
}

export interface IOption {
	label : string
	value : string
	key ?: string
	options ?: IPropType[]
	selectedValue ?: any
}

export interface IResult {
	code : string | number
	msg : string
	data : any
}

export interface ICityData {
	cityCode : number
	cityName : string
}

export interface IOptionProps {
	sourceKey ?: string
	targetKey ?: string
}

export const win : any = window
export const BMapGL = win.BMapGL

export type CallbackEventFn = (eventType : any, eventData ?: any) => void
export type CallbackFunc = (eventData ?: any) => void

export const rewardData = [
	{
		rewardType: 19,
		title: '住房补贴',
		icon: `${base.baseImgUrl}/imgs/raffle/icon_zhufang.ico`,
	},
	{
		rewardType: 18,
		title: '伙食补贴',
		icon: `${base.baseImgUrl}/imgs/raffle/icon_huoshi.ico`,
	},
	{
		rewardType: 17,
		title: '出行补贴',
		icon: `${base.baseImgUrl}/imgs/raffle/icon_jiaotong.ico`,
	},
]

export const sceneTypes = [1045, 1046, 1084, 1095]